import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Box,
  Typography,
  IconButton,
  Collapse,
  Fade,
  Grow,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import { BaseStyleType } from "src/types/style-types";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    height: "35px",
    backgroundColor: "rgba(239, 120, 120, 0.2)",
    // padding: "0px 16px",
    borderRadius: "8px",
    border: "1px solid #EF7878",
  },
  IconButton: {
    marginLeft: theme.spacing(1),
    padding: theme.spacing(1),
    marginRight: theme.spacing(-2),
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0)",
    },
  },
  ErrorIcon: {
    color: "rgba(253, 120, 121, 1)",
    fontSize: "medium",
  },
  ErrorText: {
    color: theme.palette.secondary.light,
    marginLeft: theme.spacing(2),
  },
}));

interface ErrorBoxProps extends BaseStyleType {
  message: string;
  open: boolean;
  onClose?: () => void;
}

const ErrorBox: React.FC<ErrorBoxProps> = ({
  message,
  open,
  onClose,
  className = "",
  style,
}) => {
  const classes = useStyles();
  const [isExpand, setIsExpand] = useState(false);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setIsExpand(true);
      }, 0);
    }
  }, [open]);

  const handleClose = () => {
    setIsExpand(false);
    setTimeout(() => {
      onClose?.();
    }, 300);
  };

  if (open === false) return null;

  return (
    <Collapse in={isExpand}>
      <Grow in={isExpand}>
        <Box className={`${classes.root} ${className}`} style={style}>
          {onClose && (
            <IconButton className={classes.IconButton} onClick={handleClose}>
              <Cancel className={classes.ErrorIcon} />
            </IconButton>
          )}
          <Typography variant="body2" className={classes.ErrorText}>
            {message}
          </Typography>
        </Box>
      </Grow>
    </Collapse>
  );
};

export default ErrorBox;
